.crew-option {
	display: flex;
	flex-direction: row;
}

.foreman-icon {
	:global(.icon-foreman),
	:global(.icon-foreman::before) {
		color: black !important;
	}
}